import {Box, Grid, InputBase, MenuItem, Select, Stack, Typography} from "@mui/material";
import {extensionLabel} from "../../../../project/campaigns/hooks/useAmiExtensions";
import {controlSx, selectSx, FieldLabel, FieldHelper} from "./formFieldShared";

const extensionHelper = (selected, {loading, error, extensions}) => {
  if (loading) return "Loading extensions...";
  if (error) return "Failed to load extensions";
  if (extensions.length === 0) return "No extensions yet - add one on the SIP Dialplan page";
  if (selected) return `Trunk: ${selected.trunk || "default"} · Context: ${selected.context || "default"}`;
  return "Voice bot extension answered calls go to";
};

// Where outbound calls come from and which extension answered calls are sent to
export const CampaignCallFieldsNew = ({form, setField, amiExtensions}) => {
  const {extensions, loading, error, getExtension} = amiExtensions;
  const selected = getExtension(form.extensionId);
  // Keep a saved extension that no longer exists visible instead of showing an empty select
  const missing = form.extensionId && !selected && !loading;

  return (
    <>
      <Grid item xs={12} md={4}>
        <FieldLabel required>From number</FieldLabel>
        <Box sx={controlSx}>
          <InputBase fullWidth placeholder="e.g. 38923111000" value={form.fromNumber} onChange={setField("fromNumber")} inputProps={{"aria-label": "From number"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper>Caller ID the called person sees</FieldHelper>
      </Grid>
      <Grid item xs={12} md={8}>
        <FieldLabel required>Extension</FieldLabel>
        <Select
          value={loading && form.extensionId && !selected ? "" : form.extensionId}
          onChange={setField("extensionId")}
          disabled={loading}
          renderValue={(value) => extensionLabel(getExtension(value)) || "Unknown extension"}
          sx={{...selectSx, ...((error || missing) && {boxShadow: "inset 0 0 0 1.5px #DC2626"})}}
          MenuProps={{PaperProps: {sx: {borderRadius: "12px", mt: 0.5}}}}
        >
          {missing && <MenuItem value={form.extensionId} disabled>Unknown extension</MenuItem>}
          {extensions.map(ext => (
            <MenuItem key={ext.id || ext.extension} value={String(ext.id)} disabled={!ext.id}>
              <Stack>
                <Typography sx={{fontSize: 13}}>{extensionLabel(ext)}</Typography>
                {ext.description && <Typography sx={{fontSize: 12, color: "#8A8AA0"}}>{ext.description}</Typography>}
              </Stack>
            </MenuItem>
          ))}
        </Select>
        <FieldHelper error={error || !!missing}>
          {missing ? "The selected extension no longer exists - choose another one" : extensionHelper(selected, {extensions, loading, error})}
        </FieldHelper>
      </Grid>
    </>
  )
}
